import React from "react";
import { NavLink } from "react-router-dom";
import Secheader from "./common/Secondaryheader";
import Data from "../data/ServicesCardData";

const Service = () => {
  return (
    <>
      <Secheader sectitle="Services" secdesc="Empower. Innovate. Byteskull." />

      <section>
        <div className="container mx-auto py-5">
          <div className="row d-flex items-align-center justify-content-evenly">
            {Data.map((val, ind) => (
              <div className="col-md-4 col-lg-4 mb-3 text-center" key={ind}>
                <div className="box_border col-lg-9 p-3 pt-4 m-auto rounded" style={{height:"280px",}}>
                  <NavLink
                    className="text-reset text-decoration-none"
                    to={`/service/${ind}`}
                  >
                    <img
                      src={val.scardimage}
                      className="img-fluid mb-2"
                      alt="cards"
                      width="20%"
                    />
                    <p className="my-2">{val.scardtitle}</p>
                    <p className="text-muted text-left text-xl-center text-lg-center">
                      {val.scarddesc}
                    </p>
                  </NavLink>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-light">
        <div className="container py-5 text-center">
          <p className="display-6">Not quite sure yet ?</p>
          <p className="text-muted">
            Why not visit our{" "}
            <NavLink className="text-decoration-none" to="/contact">
              contact page
            </NavLink>
            , we would love to chat with you!
          </p>
        </div>
      </section>
    </>
  );
};

export default Service;
